import { getBillingHttpClient } from './billing-http-client';
import type {
  BillingCoverageResponse,
  BillingHistoryResponse,
  BillingOverviewResponse,
  BillingPublicPlansResponse,
  BillingUsageResponse,
} from './types';

export async function fetchBillingPublicPlans(): Promise<BillingPublicPlansResponse> {
  const { data } = await getBillingHttpClient().get<BillingPublicPlansResponse>('/plans/public');
  return data;
}

export async function fetchBillingSupportRequestPlans(): Promise<BillingPublicPlansResponse> {
  const { data } =
    await getBillingHttpClient().get<BillingPublicPlansResponse>('/plans/support-request');
  return data;
}

export async function fetchBillingOverview(): Promise<BillingOverviewResponse> {
  const { data } = await getBillingHttpClient().get<BillingOverviewResponse>('/me/overview');
  return data;
}

export async function fetchBillingUsage(): Promise<BillingUsageResponse> {
  const { data } = await getBillingHttpClient().get<BillingUsageResponse>('/me/usage');
  return data ?? {};
}

export async function fetchBillingHistory(): Promise<BillingHistoryResponse> {
  const { data } = await getBillingHttpClient().get<BillingHistoryResponse>('/me/history');
  return data ?? {};
}

export async function fetchBillingCoverage(): Promise<BillingCoverageResponse> {
  const { data } = await getBillingHttpClient().get<BillingCoverageResponse>('/me/coverage');
  return data;
}
